

export default function getInfoSize(infoAreaSize,returnType){
  if(returnType===undefined){
    returnType = "normal";
  }

  let unit = "";
  if(infoAreaSize>=10000){
    infoAreaSize = Math.round((infoAreaSize/10000)*10)/10+"";
    unit = app.translator.trans("ziven-u2di.lib.unit-10k");
  }

  if(returnType==="normal"){
    return '<span>'+infoAreaSize+'<span style="margin-right: -5px;" class="u2diItemDetailsInfoValueUnit">'+unit+'</span></span>';
  }else if(returnType==="valueOnly"){
    return infoAreaSize+unit;
  }else{
    return (
      <span>
        {infoAreaSize}
        <span style="margin-right: -5px;" className="u2diItemDetailsInfoValueUnit">
          {unit}
        </span>
      </span>
    );
  }
}